<template>
  <v-container>
    <v-row>
      <v-col class="text-left  mb-12">
        <h1 class="mt-12 mb-4 font-weight-light">
          Refine your Personalized Recommendations
        </h1>
        <span>
          Help us make better recommendations. Improve your recommendations by
          rating your enrolled items, or by excluding certain items from being
          considered in your recommendations. Rate an enrolled item: choose a
          rating of 1 to 5 stars for the item you enrolled or choose to leave
          the item unrated. The ratings you submit are private. They are never
          shared with others. These ratings are only used by our recommendations
          system to give you the most accurate recommendations possible. If
          you're unsure why we're recommending a particular item, click "Why
          recommended?" link and we'll show you which of your previous ratings,
          cart additions, or enrollments influenced our suggestion. You can tell
          us about an item you like, even if you didn't enroll in it on this
          site. Locate the item, and then write a review and add a rating for
          it. We'll use that rating in our recommendations system.
        </span>

        <v-row class="mt-4" style="display:flex;align-items:center;">
          <h4 class="mr-4">
            Disable Recommendations Entirely
          </h4>
          <v-switch v-model="switch1"></v-switch>
        </v-row>
      </v-col>
    </v-row>

    <v-card v-if="switch1 == false">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Refine Your Collection</v-toolbar-title>
      </v-toolbar>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-clipboard-account</v-icon>
          Items you've Enrolled In
        </v-tab>
        <v-tab>
          <v-icon left>mdi-mouse</v-icon>
          Items you've Interacted with.
          <!-- (watched video, viewed details, added to
          cart) -->
        </v-tab>
        <v-tab>
          <v-icon left>mdi-star-circle</v-icon>
          Items you've rated
        </v-tab>
        <v-tab>
          <v-icon left>mdi-close-box</v-icon>
          Items you've marked "Not Interested"
        </v-tab>

        <v-tab-item>
          <v-card flat v-for="r in records" :key="r.ID" class="mx-auto ">
            <v-container>
              <v-row>
                <v-col class="col-4">
                  <v-img
                    height="250"
                    max-width="200"
                    contain
                    :src="r.fields.IMAGE"
                    :alt="r.fields.TITLE"
                  ></v-img>
                </v-col>
                <v-col>
                  <v-card-title class="font-weight-black">{{
                    r.fields.TITLE
                  }}</v-card-title>

                  <v-card-text class="pt-2">
                    <v-row align="center" class="mx-0">
                      <span>Rate this item:</span>
                      <v-rating
                        aria-label="Rate out of 5 stars"
                        v-model="r.newRating1"
                        half-increments
                      >
                        <template v-slot:item="props">
                          <v-icon aria-label="star" color="amber" size="20">{{
                            props.isFilled ? "mdi-star" : "mdi-star-outline"
                          }}</v-icon>
                        </template>
                      </v-rating>
                    </v-row>
                  </v-card-text>

                  <v-card-text class="pt-0">
                    <v-checkbox
                      v-model="r.checkbox1"
                      label="I prefer not to use this for recommendations."
                    ></v-checkbox>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat v-for="r in records" :key="r.ID" class="mx-auto ">
            <v-container>
              <v-row>
                <v-col class="col-4">
                  <v-img
                    height="250"
                    max-width="200"
                    contain
                    :src="r.fields.IMAGE"
                    :alt="r.fields.TITLE"
                  ></v-img>
                </v-col>
                <v-col>
                  <v-card-title class="font-weight-black">{{
                    r.fields.TITLE
                  }}</v-card-title>

                  <v-card-text class="pt-2">
                    <v-row align="center" class="mx-0">
                      <span>Rate this item:</span>
                      <v-rating
                        aria-label="Rate out of 5 stars"
                        v-model="r.newRating2"
                        half-increments
                      >
                        <template v-slot:item="props">
                          <v-icon aria-label="star" color="amber" size="20">{{
                            props.isFilled ? "mdi-star" : "mdi-star-outline"
                          }}</v-icon>
                        </template>
                      </v-rating>
                    </v-row>
                  </v-card-text>

                  <v-card-text class="pt-0">
                    <v-checkbox
                      v-model="r.checkbox2"
                      label="I prefer not to use this for recommendations."
                    ></v-checkbox>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat v-for="r in records" :key="r.ID" class="mx-auto ">
            <v-container>
              <v-row>
                <v-col class="col-4">
                  <v-img
                    height="250"
                    max-width="200"
                    contain
                    :src="r.fields.IMAGE"
                    :alt="r.fields.TITLE"
                  ></v-img>
                </v-col>
                <v-col>
                  <v-card-title class="font-weight-black">{{
                    r.fields.TITLE
                  }}</v-card-title>

                  <v-card-text class="pt-2">
                    <v-row align="center" class="mx-0">
                      <span>Rate this item:</span>
                      <v-rating
                        aria-label="Rate out of 5 stars"
                        v-model="r.newRating3"
                        half-increments
                      >
                        <template v-slot:item="props">
                          <v-icon aria-label="star" color="amber" size="20">{{
                            props.isFilled ? "mdi-star" : "mdi-star-outline"
                          }}</v-icon>
                        </template>
                      </v-rating>
                    </v-row>
                  </v-card-text>

                  <v-card-text class="pt-0">
                    <v-checkbox
                      v-model="r.checkbox3"
                      label="I prefer not to use this for recommendations."
                    ></v-checkbox>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat v-for="r in records" :key="r.ID" class="mx-auto ">
            <v-container>
              <v-row>
                <v-col class="col-4">
                  <v-img
                    height="250"
                    max-width="200"
                    contain
                    :src="r.fields.IMAGE"
                    :alt="r.fields.TITLE"
                  ></v-img>
                </v-col>
                <v-col>
                  <v-card-title class="font-weight-black">{{
                    r.fields.TITLE
                  }}</v-card-title>

                  <v-card-text class="pt-2">
                    <v-row align="center" class="mx-0">
                      <span>Rate this item:</span>
                      <v-rating
                        aria-label="Rate out of 5 stars"
                        v-model="r.newRating4"
                        half-increments
                      >
                        <template v-slot:item="props">
                          <v-icon aria-label="star" color="amber" size="20">{{
                            props.isFilled ? "mdi-star" : "mdi-star-outline"
                          }}</v-icon>
                        </template>
                      </v-rating>
                    </v-row>
                  </v-card-text>

                  <v-card-text class="pt-0">
                    <v-checkbox
                      v-model="r.checkbox4"
                      label="I prefer not to use this for recommendations."
                    ></v-checkbox>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Refine",
  data() {
    return {
      checkbox1: null,
      checkbox2: null,
      checkbox3: null,
      checkbox4: null,
      records: [],
      newRating1: null,
      newRating2: null,
      newRating3: null,
      newRating4: null,
      switch1: false,
    };
  },
  mounted() {
    this.getFirstThreeRecords();
  },
  methods: {
    getFirstThreeRecords() {
      axios
        .get(
          "https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?maxRecords=3&view=Grid%20view",
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            // console.log(r.data.records);
            this.records = r.data.records;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>

<style scoped>
.v-tab {
  max-width: unset;
  justify-content: start;
}
</style>
